import { useMemo } from 'react'

import { y } from '@circlefin/form'
import { useStates } from '@features/locales/hooks/states'
import { CountryCode, L3OnboardingKioksStatesOptions } from '@shared/graphql'
import useTranslation from 'next-translate/useTranslation'

import { requiredMessage } from '../../../yup/utils'
import { L3OnboardingMultiSelectCombobox } from '../../L3OnboardingMultiSelectCombobox'

import type { L3OnboardingMultiSelectComboboxVariantProps } from '../types'
import type { MultiSelectComboboxItem } from '@circlefin/components/lib/MultiSelectCombobox'
import type { StateCode } from '@shared/graphql'

export type KioskLocationsUsStatesType =
  | StateCode
  | L3OnboardingKioksStatesOptions

export const kioksLocationsUsStatesSchema = y
  .array()
  .of(y.mixed<KioskLocationsUsStatesType>())
  .min(1, requiredMessage)

export const KioskLocationsUsStates: React.FC<
  L3OnboardingMultiSelectComboboxVariantProps
> = (props) => {
  const { t } = useTranslation('l3Onboarding')
  const { states } = useStates({
    country: CountryCode.US,
  })

  const items: Array<MultiSelectComboboxItem<KioskLocationsUsStatesType>> =
    useMemo(() => {
      return [
        {
          label: t(
            `forms.entityOperations.kioskLocationsUsStates.options.${L3OnboardingKioksStatesOptions.notApplicable}`,
          ),
          value: L3OnboardingKioksStatesOptions.notApplicable,
          selectAll: true,
        },
        ...states.toDropdown(),
      ]
    }, [t, states])

  return (
    <L3OnboardingMultiSelectCombobox
      items={items}
      label={t`forms.entityOperations.kioskLocationsUsStates.label`}
      {...props}
    />
  )
}
